import HeatmapSettings from './Heatmap';
export default HeatmapSettings;